module.exports = __webpack_public_path__ + "static/www/img/course_mvp.b0be582.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/course/course_mvp.jpg
// module id = 380
// module chunks = 1